import { instance } from '@/api/index';
import dayjs from "dayjs";

export function getComboBoxList(retrieveData) {
    let params = {
        cmmCode: "getComboList",
        cmmMsg: "Search Combo Box List",
        cmmTime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
        cmmData: {
            ...retrieveData
        }
    }
    return instance.post('/api/comn/c101', { ...params });
}

export function getIfProductInfoList(retrieveData) {
    let params = {
        cmmCode: "getIfProductInfoList",
        cmmMsg: "Search Product List",
        cmmTime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
        cmmData: {
            ...retrieveData
        }
    }
    return instance.post('/api/comn/i101', { ...params });
}

export function getIfEngineInfoList(retrieveData) {
    let params = {
        cmmCode: "getIfEngineInfoList",
        cmmMsg: "Search Engine List",
        cmmTime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
        cmmData: {
            ...retrieveData
        }
    }
    return instance.post('/api/comn/i102', { ...params });
}

export function getAccessToken4Digitaltwin(retrieveData) {
    let params = {
        cmmCode: "getAccessToken4Digitaltwin",
        cmmMsg: "getAccessToken4Digitaltwin",
        cmmTime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
        cmmData: {
            ...retrieveData
        }
    }
    return instance.post('/api/comn/c106', { ...params });
}















export function getMainChartInfoList(retrieveData) {
    let params = {
        cmmCode: "getMainChartInfoList",
        cmmMsg: "getMainChartInfoList",
        cmmTime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
        cmmData: {
            ...retrieveData
        }
    }
    return instance.post('/api/comn/c104', { ...params });
}

export function getUserLoginMenuList(userId) {
    let params = {
        cmmCode: "PCSRoleUserTree",
        cmmMsg: "PCS Role User Tree",
        cmmTime: dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'),
        cmmData: {
            userId: userId
        }
    }

    return instance.post('/login/user/r208', { ...params });
}